var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.784,30.832H31.216c-5.311,0-9.631,4.321-9.631,9.632v16.849c0,4.592,3.254,8.461,7.578,9.407v7.497 c0,0.809,0.487,1.538,1.234,1.848c0.248,0.103,0.507,0.152,0.765,0.152c0.521,0,1.032-0.203,1.415-0.586l8.688-8.687h23.521 c5.311,0,9.632-4.321,9.632-9.632V40.464C74.416,35.153,70.095,30.832,64.784,30.832z M70.416,57.312 c0,3.105-2.526,5.632-5.632,5.632H40.435c-0.53,0-1.039,0.211-1.414,0.586l-5.859,5.858v-4.447c0-1.099-0.887-1.992-1.986-2 c-3.083-0.021-5.592-2.547-5.592-5.629V40.464c0-3.105,2.526-5.632,5.631-5.632h33.568c3.105,0,5.632,2.526,5.632,5.632V57.312z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.74558de1757129012032a16227918cc5.svg";
export { ForwardRef as ReactComponent };